import PropTypes from "prop-types"
import React from "react"

import { Button } from "./Buttons"
import IntakeFormRow, { VARIANT_DEFAULT, VARIANT_COMPLETED } from "./IntakeFormRow"

export default function IntakeFormListSection({
  forms = [],
  count,
  actionLabel,
  onAction,
  onFormAction,
  actionIdsByStatus,
  className,
  showActionButton = true,
  multipleIntakeFormsEnabled = true
}) {
  const displayCount = count !== undefined ? count : forms.length
  const sectionTitle = multipleIntakeFormsEnabled !== false ? "Intake forms" : "Intake form"

  const getVariant = (form) => {
    const status = form.status ?? form.submissionStatus
    if (status === "completed") return VARIANT_COMPLETED
    return VARIANT_DEFAULT
  }

  const getRowStatus = (form) => {
    const status = form.status ?? form.submissionStatus
    if (status === "completed") return "completed"
    if (status === "sent") return "sent"
    return "not_sent"
  }

  const getActionIds = (form) => {
    if (!actionIdsByStatus) return undefined
    const status = getRowStatus(form)
    return actionIdsByStatus[status] ?? []
  }

  return (
    <section className={className} data-testid="intake-form-list-section">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-bold text-gray-dark">
          {sectionTitle}
          {displayCount >= 0 && <span className="ml-1 font-normal text-gray-dark">({displayCount})</span>}
        </h3>
        {showActionButton && actionLabel && onAction && (
          <Button type="secondary" onClick={onAction} className="shrink-0">
            {actionLabel}
          </Button>
        )}
      </div>
      <ul className="mt-3 space-y-2">
        {forms.map((form) => (
          <li key={form.id}>
            <IntakeFormRow
              form={{
                id: form.id,
                name: form.name,
                completedAt: form.completedAt
              }}
              variant={getVariant(form)}
              status={getRowStatus(form)}
              completedAt={form.completedAt}
              actionIds={getActionIds(form)}
              onAction={onFormAction}
            />
          </li>
        ))}
      </ul>
    </section>
  )
}

IntakeFormListSection.propTypes = {
  forms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string,
      submissionStatus: PropTypes.string,
      completedAt: PropTypes.string
    })
  ),
  count: PropTypes.number,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  showActionButton: PropTypes.bool,
  multipleIntakeFormsEnabled: PropTypes.bool,
  onFormAction: PropTypes.func,
  actionIdsByStatus: PropTypes.shape({
    not_sent: PropTypes.arrayOf(PropTypes.oneOf(["view", "resend", "remove"])),
    sent: PropTypes.arrayOf(PropTypes.oneOf(["view", "resend", "remove"])),
    completed: PropTypes.arrayOf(PropTypes.oneOf(["view", "resend", "remove"]))
  }),
  className: PropTypes.string
}
